// extracted by mini-css-extract-plugin
module.exports = {"Auth":"ForgotPassword_Auth__2L_h6"};